module.exports = __webpack_public_path__ + "media/images/mobile/news/md_banner-370c9861b9927cdda85c8e2ebe191d0f.jpg";